var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-2"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('EventCalendar')],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('SearchHorseBlock')],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('ToExpireProductsBlock')],1),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }